import { FreeDataWrapper, FreeDataCriteria, FreeDataScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { FreedataDataload } from '../../../vo/core/freedata.dataload';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';

/**
 * appels pour synchro des FDs remote
 */
export class FreedataCmd extends WizCommand<FreeDataWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  public dataLoad: FreedataDataload; // le pool de chargement
 
  /** retourne un wrapper pre-alimenté pour un appel complet du FD (avec values) */
  public  freedataWrapper(): FreeDataWrapper {
    const wrapper: FreeDataWrapper = new FreeDataWrapper();
    wrapper.criteria = new FreeDataCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new FreeDataScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.scenario.manageArgs = true;
    wrapper.scenario.manageLevels = true;
    wrapper.scenario.manageValues = false;
    return wrapper;
  }

  /** 
   * collecte des FD modifiés / créés sur base NumRev
   * 
   * @param dataload le pool de chargement
   * @param freedataCode cible, pour refresh avant commit
   * @param callback de retour
   * @returns la commande préparée
   */
  public findFromRevNumber(dataload: FreedataDataload, freedataCode?: string, callback?: Function): FreedataCmd {
    this.dataLoad = dataload;
    const wrapper: FreeDataWrapper = this.freedataWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria.revisionNumber = dataload.revisionNumber;
    if(freedataCode) { // recherche ciblée pour 1 Freedata
      wrapper.criteria.freeDataCodeList = [freedataCode];
    }
    this.configureRemote(ExternalAPI.FREEDATA_API, wrapper, callback);

    return this;
  }

  public wizResult(): void {
    super.wizResult();
    if (this.result) {
      this.dataLoad.freedatas = this.result.entities;
    } else {
      console.log('freedataCmd no result');
    }
  }

}
